export default "__VITE_ASSET__5bf17b66__"